import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const LargeNotificationIcon = ({
  stroke,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={128}
      height={128}
      fill="none"
      {...props}
    >
      <path
        fill={strokeColor}
        d="M102.75 65.716V53.75c0-17.456-11.603-32.25-27.5-37.082V11.25C75.25 5.047 70.203 0 64 0S52.75 5.047 52.75 11.25v5.418C36.853 21.5 25.25 36.294 25.25 53.75v11.966c0 15.333-5.845 29.872-16.457 40.939A3.748 3.748 0 0 0 11.5 113h34.127c1.742 8.548 9.318 15 18.373 15 9.055 0 16.63-6.452 18.373-15H116.5a3.749 3.749 0 0 0 2.707-6.345c-10.612-11.067-16.457-25.607-16.457-40.94ZM60.25 11.25A3.754 3.754 0 0 1 64 7.5a3.754 3.754 0 0 1 3.75 3.75v3.932A39.061 39.061 0 0 0 64 15c-1.265 0-2.516.063-3.75.182V11.25ZM64 120.5c-4.889 0-9.057-3.135-10.605-7.5h21.21c-1.548 4.365-5.716 7.5-10.605 7.5Zm-44.418-15c8.54-11.448 13.168-25.302 13.168-39.784V53.75C32.75 36.519 46.769 22.5 64 22.5s31.25 14.019 31.25 31.25v11.966c0 14.482 4.627 28.336 13.168 39.784H19.582Z"
      />
    </svg>
  );
};
